<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'adjustmentDetail',
    components: {
      baseEdit,
    },
  };
</script>
